/** What happened to a product's place on a scale. */
export enum ScaleMovementAction {
  ATTACH = 1,
  DETACH = 2,
  /** Between two slots of the same scale; `fromHotkey` is filled only here. */
  MOVE = 3,
}

export const getScaleMovementAction = (action: ScaleMovementAction) => {
  switch (action) {
    case ScaleMovementAction.ATTACH:
      return "scale_movement_attach";
    case ScaleMovementAction.DETACH:
      return "scale_movement_detach";
    case ScaleMovementAction.MOVE:
      return "scale_movement_move";
    default:
      return "-";
  }
};

export const getScaleMovementActionColor = (action: ScaleMovementAction) => {
  switch (action) {
    case ScaleMovementAction.ATTACH:
      return "green";
    case ScaleMovementAction.DETACH:
      return "red";
    case ScaleMovementAction.MOVE:
      return "blue";
    default:
      return "default";
  }
};

/** Why it happened. Most detaches are a side effect rather than a button press,
 *  which is why `createdBy` is usually empty and this column answers instead. */
export enum ScaleMovementReason {
  MANUAL = 1,
  PRODUCT_DELETED = 2,
  PRODUCT_DEACTIVATED = 3,
  PRODUCT_DEACTIVATED_IN_STORE = 4,
  PRODUCT_UNWEIGHED = 5,
  MOVED_TO_ANOTHER_SCALE = 6,
  STALE_ROW_CLEANUP = 7,
}

export const getScaleMovementReason = (reason: ScaleMovementReason) => {
  switch (reason) {
    case ScaleMovementReason.MANUAL:
      return "scale_reason_manual";
    case ScaleMovementReason.PRODUCT_DELETED:
      return "scale_reason_product_deleted";
    case ScaleMovementReason.PRODUCT_DEACTIVATED:
      return "scale_reason_product_deactivated";
    case ScaleMovementReason.PRODUCT_DEACTIVATED_IN_STORE:
      return "scale_reason_product_deactivated_in_store";
    case ScaleMovementReason.PRODUCT_UNWEIGHED:
      return "scale_reason_product_unweighed";
    case ScaleMovementReason.MOVED_TO_ANOTHER_SCALE:
      return "scale_reason_moved_to_another_scale";
    case ScaleMovementReason.STALE_ROW_CLEANUP:
      return "scale_reason_stale_row_cleanup";
    default:
      return "-";
  }
};
